<template>
    <div class="sas-dashboard-container">
        <div class="slider-btn" @click="openDraw">
            <el-tooltip class="item" effect="dark" :content="$t('sas_dashboard_title')" placement="left" popper-class="popper-cls">
                <img :src="dashboard_icon" alt="" class="history-icon" width="100%">
            </el-tooltip>
        </div>
        <div class="body">
            <el-drawer
                class="drawer-wrapper"
                :size="exportLoading ? '30%' : '50%'"
                :visible.sync="show"
                :append-to-body="true"
                :modal-append-to-body="false"
                :modal="false"
                direction="rtl"
                :before-close="onDrawClose"
                @open="onDrawOpen"
                v-loading="loading"
                destroy-on-close>
                <template #title>
                    <div class="draw-title">
                        <div class="draw-title-text">{{ $t('sas_dashboard_title') }}</div>
                        <!-- <el-button class="draw-title-export-btn" size="mini" @click="onExportClick" :loading="exportLoading">{{ $t('COMMON_EXPORT') }}</el-button> -->
                    </div>
                </template>
                <template>
                    <div class="draw-body">
                        <div class="draw-section-title">
                            <div class="section-title-text">{{ $t('each_milestone_completion_time_allocation') }}</div>
                            <el-cascader
                                class="section-title-cascader"
                                v-model="dashboardMilestoneId1"
                                :options="cascaderOptions1"
                                size="mini"
                                :props="{
                                    value: 'id',
                                    label: 'milestoneName',
                                    children: 'childMilestoneBO'
                                }"
                                @change="onChart1SelectChange"
                            ></el-cascader>
                        </div>
                        <div id="chart1" class="section-chart-container" ref="chart1"></div>

                        <div class="draw-section-title">
                            <div class="section-title-text">{{ $t('each_milestone_progress_overview') }}</div>
                            <el-cascader
                                class="section-title-cascader"
                                v-model="dashboardMilestoneId2"
                                :options="cascaderOptions2"
                                size="mini"
                                :props="{
                                    value: 'id',
                                    label: 'milestoneName',
                                    children: 'childMilestoneBO'
                                }"
                                @change="onChart2SelectChange"
                            ></el-cascader>
                        </div>
                        <div id="chart2" class="section-chart-container" ref="chart2"></div>

                        <div class="draw-section-title">
                            <div class="section-title-text">{{ $t('all_entities_progress_overview') }}</div>
                            <el-select
                                class="section-title-cascader"
                                size="mini"
                                v-model="dashboardMilestoneId3">
                                <el-option
                                    v-for="(v, k) in cascaderOptions3"
                                    :key="k"
                                    :label="v.milestoneName"
                                    :value="v.id"
                                ></el-option>
                            </el-select>
                        </div>
                        <div id="chart3" class="section-chart-container-3" ref="chart3">
                            <div class="chart3-egs">
                                <div class="eg-item">
                                    <div ref="egGreen" class="eg-color eg-color-green"></div>
                                    <div class="eg-text">{{ $t('sas_dashboard_examples_14') }}</div>
                                </div>
                                <div class="eg-item">
                                    <div ref="egGray" class="eg-color eg-color-gray"></div>
                                    <div class="eg-text">{{ $t('sas_dashboard_examples_23') }}</div>
                                </div>
                            </div>
                            <el-table
                                :data="statsData[2]" 
                                :cell-style="chart3CellStyle"
                                :row-style="{ height: '44px' }"
                                :fit="true">
                                <el-table-column fixed width="150" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span class="chart3-entity-name-inner" v-html="scope.row.entityName"></span>    
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="chart3Level1Label"
                                    align="center">
                                    <el-table-column
                                        v-for="(v, k) in chart3Level2Columns"
                                        :key="k"
                                        :column-key="v.id"
                                        :label="v.milestoneName"
                                        width="100">
                                        <template #header>
                                            <el-tooltip placement="top" effect="light">
                                                <div slot="content" v-html="v.milestoneName"></div>
                                                <div class="chart3-header-outer">
                                                    <span class="chart3-header-inner" v-html="v.milestoneName"></span>    
                                                </div>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </template>
            </el-drawer>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import * as _ from 'lodash'
import * as echarts from 'echarts'
import 'jspdf-autotable'


export default {
    name: 'SASDashboard',
    props: {
        milestoneQueryList: {
            type: Array,
            default: () => []
        },
        tableColumns: {
            type: Array,
            default: () => []
        },
        allEntityIds: {
            type: Array,
            default: () => []
        },
        filterChange: {
            type: Function,
            default: () => {}
        },
        tableFilter: {}
    },
    data() {return {
        show: false,
        dashboard_icon: require(`@/assets/img/icon-statisticaldata.svg`),
        loading: false,
        dashboardMilestoneId1: [],
        dashboardMilestoneId2: [],
        dashboardMilestoneId3: [],
        cascaderOptions1: [],
        cascaderOptions2: [],
        cascaderOptions3: [],
        statsData: [
            [],
            [],
            []
        ],
        statsData0Sort: [],
        chart1: null,
        chart2: null,
        chart3: null,
        chart3ShowEntityTooltip: {},
        exportLoading: false,
        icon1: require(`@/assets/img/icon-not-applicable.svg`),
        icon2: require(`@/assets/img/icon-completed.svg`)
    }},
    methods: {
        onChart1SelectChange() {
            this.getData([1])
        },
        onChart2SelectChange() {
            this.getData([2])
        },
        chart3CellStyle({row, column, rowIndex, columnIndex}) {
            if (columnIndex == 0) {
                return { backgroundColor: 'white', height: '44px' }    
            }
            const cellColumn = this.chart3Level2Columns[columnIndex - 1]
            const find = row.mileStoneRecordList.find(vv => vv.milestoneId == cellColumn.id)
            let color = ''
            if (find && find.state) {
                color = [1, 4].includes(find.state) ? '#addec6' : ([2, 3].includes(find.state) ? '#e1e3e6' : 'white')
            } else {
                color = 'white'
            }
            return { backgroundColor: color, height: '44px' }
        },
        getStatsData0Sort() {
            this.statsData0Sort = Object.keys(this.statsData[0])
                    .sort((a, b) => Date.parse(new Date(a)) - Date.parse(new Date(b)))
                    .map(k => ({
                        date: `${k}`,
                        value: this.statsData[0][k]
                    }))
        },
        drawCharts() {
            this.chart1 = echarts.init(document.getElementById('chart1'))
            this.chart1.setOption({
                xAxis: {
                    type: 'category',
                    data: this.statsData0Sort.map(v => v.date)
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1
                },
                series: [
                    {
                        data: this.statsData0Sort.map(v => v.value.length),
                        type: 'line',
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                color: 'black',
                                fontSize: 12
                            }
                        }
                    }
                ]
            })

            let data2 = []
            let colors2 = []
            Object.keys(this.statsData[1]).forEach(k => {
                const name = {
                    1 : this.$t('ACCOUNT_STATUS_NOT_APPLICABLE'),
                    3 : this.$t('ACCOUNT_STATUS_NOT_START'),
                    2 : this.$t('ACCOUNT_STATUS_NOT_PROGRESS'),
                    4 : this.$t('ACCOUNT_STATUS_NOT_COMPLETE'),
                }[k]
                const value = this.statsData[1][k].number
                const percent = this.statsData[1][k].percent
                data2.push({
                    value: this.statsData[1][k].number,
                    name
                })
                colors2.push({
                    1: '#8893a7',
                    3: '#fd349c',
                    2: '#00b8f5',
                    4: '#00c0ae'
                }[k])
            })
            this.chart2 = echarts.init(document.getElementById('chart2'))
            this.chart2.setOption({
                tooltip: {
                    trigger: 'item'
                },
                color: colors2,
                legend: {
                    orient: 'vertical',
                    right: '5%',
                    top: '50%',
                    align: 'left',
                    icon: 'circle'
                },
                label: {
                    show: true,
                    formatter: '{b0}\n {c0}【{d0}%】'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        data: data2,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        center: ['40%', '60%']
                    }
                ]
            })
            this.chart1.on('click', this.clickChart1)
            this.chart2.on('click', this.clickChart2)
        },
        clickChart1(e) {
            const entityIds = this.statsData0Sort[e.dataIndex].value
            this.$store.commit('common/setEntityIds', entityIds)
            this.filterChange()
            this.onDrawClose()
        },
        clickChart2(e) {
            const entityIds = Object.values(this.statsData[1])[e.dataIndex].entityIds
            this.$store.commit('common/setEntityIds', entityIds)
            this.filterChange()
            this.onDrawClose()
        },
        getData(specialPoint = []) {
            this.loading = true
            let promiseArr = []
            if (specialPoint.length == 0) specialPoint = [1, 2, 3]
            if (specialPoint.includes(1)) {
                promiseArr.push(
                    API.status.dashboardTimeAllocation({ ...this.tableFilter, dashboardMilestoneId: this.dashboardMilestoneId1[1] }).then(res => {
                        if (res.code == '1') {
                            this.statsData[0] = res.data
                            this.getStatsData0Sort()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    }).catch(e => { console.error(e); }).finally(() => {})
                )
            }
            if (specialPoint.includes(2)) {
                promiseArr.push(
                    API.status.dashboardStatusOverview({ ...this.tableFilter, dashboardMilestoneId: this.dashboardMilestoneId2[1] }).then(res => {
                        if (res.code == '1') {
                            this.statsData[1] = res.data
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    }).catch(e => { console.error(e); }).finally(() => {})
                )
            }
            if (specialPoint.includes(3)) {
                promiseArr.push(
                    API.status.getStatusList({
                        ...this.tableFilter,
                        pageSize: 9999999,
                        pageNum: 1
                    }).then(res => {
                        if (res.code == '1') {
                            if (res.data && res.data.records && res.data.records.length > 0) {
                                this.statsData[2] = res.data.records
                                res.data.records.forEach(v => {
                                    this.chart3ShowEntityTooltip[v.id] = false
                                })
                            } else {
                                this.statsData[2] = []
                            }
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    }).catch(e => { console.error(e); }).finally(() => {})
                )
            }
            Promise.all(promiseArr).then(res => {
                this.drawCharts()
            }).catch(e => {
                console.error(e)
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {
                this.loading = false
            })
            
        },
        onDrawOpen() {
            // 把父页面传进来的表头复制三份，给三个下拉用
            function noDisable(val) {
                val.forEach(v => {
                    v.disabled = false
                    if (v.childMilestoneBO && v.childMilestoneBO.length > 0) {
                        v.childMilestoneBO.forEach(vv => vv.disabled = false)
                    }
                })
                return val
            }
            if (this.cascaderOptions1.length == 0) this.cascaderOptions1 = noDisable(_.cloneDeep(this.tableColumns))
            if (this.cascaderOptions2.length == 0) this.cascaderOptions2 = noDisable(_.cloneDeep(this.tableColumns))
            if (this.cascaderOptions3.length == 0) this.cascaderOptions3 = noDisable(_.cloneDeep(this.tableColumns))

            // 三个下拉都塞上第一个元素
            if (this.dashboardMilestoneId1.length == 0) this.dashboardMilestoneId1 = [this.tableColumns[0].id, this.tableColumns[0].childMilestoneBO[0].id]
            if (this.dashboardMilestoneId2.length == 0) this.dashboardMilestoneId2 = [this.tableColumns[0].id, this.tableColumns[0].childMilestoneBO[0].id]
            if (this.dashboardMilestoneId3.length == 0) this.dashboardMilestoneId3 = this.tableColumns[0].id
            
            this.getData([1, 2, 3])
        },
        onDrawClose() {
            this.show = false
        },
        openDraw() {
            this.show = true
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds'
        }),
        chart3Level1Label() {
            const find = this.cascaderOptions3.find(v => v.id == this.dashboardMilestoneId3)
            if (find && find.milestoneName) {
                return find.milestoneName
            } else {
                return ''
            }
        },
        chart3Level2Columns() {
            // return this.cascaderOptions3.reduce((pre, cur) => {
            //     pre = [...pre, ...cur.childMilestoneBO]
            //     return pre
            // }, [])
            const find = this.cascaderOptions3.find(v => v.id == this.dashboardMilestoneId3)
            if (find && find.childMilestoneBO && find.childMilestoneBO.length > 0) {
                return find.childMilestoneBO
            } else {
                return []
            }
        },
    },
}
</script>
<style scoped>
.sas-dashboard-container {
    
}
.slider-btn {
    position: fixed;
    top: 340px;
    right: 0;
    width: 40px;
    height: 40px;
    font-size: 22px;
    text-align: center;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    transition: right .3s cubic-bezier(.9, 0, .3, .7);
    pointer-events: auto;
    color: #ffff;
    background: #7213ea; 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2001;
}
.history-icon {
    position: absolute;
    width: 22px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}
::v-deep .el-drawer__header {
    border-bottom: solid 1px #eaebec;
    padding-bottom: 20px;
}
.sas-dashboard-container .body {
    width: 100%;
    overflow-x: hidden;
}
.draw-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.draw-title .draw-title-text {
    font-size: 15PX;
    font-weight: 700;
    color: #263349;
}
.draw-title .draw-title-export-btn {
    margin-right: 20px;
}
.draw-body {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.draw-body .draw-section-title {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.draw-body .draw-section-title .section-title-text {
    margin-left: 15PX;
    border-left: solid 5px #3879eb;
    padding-left: 10px;
    font-size: 13PX;
    font-weight: 600;
}
.draw-body .draw-section-title .section-title-cascader {
    margin-right: 15px;
    width: 50%;
}
::v-deep .el-cascader-node__label {
    font-size: 12px;
}
::v-deep .el-cascader-menu {
    width: 180px;
}
.draw-body .section-chart-container {
    width: 100%;
    height: 400px;
}
.draw-body .section-chart-container-3 {
    width: calc(100% - 20px);
    margin-left: 10px;
    margin-right: 10px;
}
::v-deep .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: none;
    border: solid 1px #ebeef5;
}
.chart3-entity-name-outer {
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.chart3-entity-name-inner {}

.chart3-header-outer {
    width: 95px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.chart3-header-inner {}

.chart3-egs {
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.chart3-egs .eg-item {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.chart3-egs .eg-item:nth-of-type(1) {
    margin-right: 20px;
}
.chart3-egs .eg-item .eg-color {
    width: 25px;
    height: 15px;
}
.chart3-egs .eg-item .eg-color-green {
    background-color: #addec6;
}
.chart3-egs .eg-item .eg-color-gray {
    background-color: #e1e3e6;
}
.chart3-egs .eg-item .eg-text {
    margin-left: 5px;
    font-size: 10px;
}
</style>